import Utils from '../../services/Utils'
import { FormErrorStrategy } from '../config/ErrorHandler'
import { GApi, defineCancelApiObject, defaultHeaders } from '../config/GApi'

const UserApi = {
  get: async function (userId, cancel = false) {
    const response = await GApi.request({
      url: '/global-reporting/user/' + userId,
      method: 'GET',
      headers: defaultHeaders(),
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
  setDefaultReport: async function (reportId, userId, cancel = false) {
    const response = await GApi.request({
      url: 'global-reporting/default-user-report/' + reportId,
      method: 'PUT',
      headers: defaultHeaders(),
      data: { userId: userId },
      errorStrategy: FormErrorStrategy,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
}

// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(UserApi)

export default UserApi
